export const COUPON_ID_DEVICE =
  process.env.REACT_APP_SERVER_BASE_URL === 'stg' ? 118 : 27;

export const COUPON_ID_APP_INSTALL =
  process.env.REACT_APP_SERVER_BASE_URL === 'stg' ? 119 : 28;
